import React from 'react';
import ModalBase from 'components/features/modal/Modal';

type Props = {
  isShow: boolean;
  close: () => void;
};

const Modal: React.FC<Props> = props => {
  if (!props.isShow) {
    return null;
  }

  return (
    <ModalBase
      onClose={() => {
        return;
      }}>
      {props.children}
    </ModalBase>
  );
};

export default Modal;
